import React from 'react';

import PropTypes from 'prop-types';
import FaEye from 'react-icons/lib/fa/eye';
import FaEyeSlash from 'react-icons/lib/fa/eye-slash';

function PasswordIcon(props) {
    const {
        className,
        dataId,
        passwordAsPlaintext,
        onClick,
        ...otherProps
    } = props;
    const Icon = passwordAsPlaintext
        ? FaEyeSlash
        : FaEye;

    return (
        <span
            className={className}
            data-id={dataId}
            onClick={onClick}
        >
            <Icon {...otherProps} />
        </span>
    );
}

PasswordIcon.propTypes = {
    className: PropTypes.string,
    'data-id': PropTypes.string,
    passwordAsPlaintext: PropTypes.bool,
    onClick: PropTypes.func,
};

PasswordIcon.defaultProps = {
    className: '',
    'data-id': '',
    passwordAsPlaintext: false,
    onClick() {},
};

export default PasswordIcon;
